<section class="flex h-full w-full min-h-0 flex-col rounded-md border border-shui-ui-2 bg-shui-base-1">
    <header class="mb-2 flex items-center justify-start">
        <div class="flex items-center">
            <sh-icon
                icon="arrow-line-left-s"
                class="text-base"
                (click)="showPreviousYear()"
                [attr.aria-label]="'common.out-of-office.manager.previous-year' | translate"
                button
            ></sh-icon>
            <h2 class="text-xl font-semibold text-shui-text-strong">{{ displayedYear() }}</h2>
            <sh-icon
                icon="arrow-line-right-s"
                class="text-base"
                (click)="showNextYear()"
                [attr.aria-label]="'common.out-of-office.manager.next-year' | translate"
                button
            ></sh-icon>
        </div>
    </header>

    <div class="grid flex-1 min-h-0 grid-cols-1 content-start gap-1 overflow-auto xxl:grid-cols-2">
        @for (month of months(); track month.index) {
            <article class="rounded-md border border-shui-ui-2 bg-shui-base-3 p-4 pt-2">
                <h3 class="mb-6 text-base text-center font-semibold text-shui-text-strong">{{ month.name }}</h3>

                <div class="grid grid-cols-7 gap-1">
                    @for (weekday of weekdayLabels(); track weekday) {
                        <div class="pb-2 text-center text-xs font-semibold uppercase text-shui-text-subtle">
                            {{ weekday }}
                        </div>
                    }

                    @for (week of month.weeks; track $index) {
                        @for (cell of week; track $index) {
                            @if (cell.day !== null) {
                                <div
                                    class="flex h-9 items-center justify-center rounded-md text-sm text-shui-text-strong"
                                    [class.bg-shui-tint-active-150]="cell.isInRange && !cell.isSelected"
                                    [class.bg-shui-tint-active-250]="cell.isSelected"
                                    [class.font-semibold]="cell.isToday || cell.isSelected"
                                    [class.ring-2]="cell.isToday"
                                    [class.ring-shs-orange]="cell.isToday"
                                    [class.!text-shs-orange]="cell.isToday"
                                >
                                    {{ cell.day }}
                                </div>
                            } @else {
                                <div class="h-9"></div>
                            }
                        }
                    }
                </div>
            </article>
        }
    </div>
</section>
